export const NOT_AVAILABLE = 'N/A';
export const AVAILABLE = 'A';
export const RECENTLY_REPLACED = 'recently replaced';